// PRD-17 §FR-1..3 — display-only access guard for the director surface.
//
// Wraps the `/direccion` route. If the gate fails the user is redirected
// silently to `/` — no error, no flash. Identical predicate to the one
// used by the sidebar item and the settings card so all three surfaces
// can never disagree.

import { useAuth } from "@auth/AuthContext"
import { Navigate } from "react-router-dom"

import { isDirector } from "../access"

interface Props {
  children: React.ReactNode
}

export function DirectorOnly({ children }: Props) {
  const { professor } = useAuth()
  if (!isDirector(professor)) return <Navigate to="/" replace />
  return <>{children}</>
}
